"use client";

import { useCallback } from "react";

import Link from "next/link";

import { Column, Row } from "@/components/containers";
import { ButtonRound } from "@/components/inputs";
import { MAX_CHARGE_POINT } from "@/configs/system";
import { usePostPosaCharge } from "@/generated/open-api/posa/posa";

import { ChargePointDetails } from "./ChargePointDetails";

export interface PosaChargeConfirmProps {
  currentPoints: number;
  chargePoints: number;
  posaCardNumber: string;
  onChargeSuccess: () => void;
}

export function PosaChargeConfirm({
  currentPoints,
  chargePoints,
  posaCardNumber,
  onChargeSuccess,
}: PosaChargeConfirmProps) {
  const { mutateAsync: postPosaCharge, isPending: isPostPosaChargePending } = usePostPosaCharge();
  const isPointOverMax = chargePoints + currentPoints > MAX_CHARGE_POINT;

  const handleCharge = useCallback(async () => {
    await postPosaCharge({
      data: {
        cardNumber: posaCardNumber,
      },
    });
    onChargeSuccess();
  }, [onChargeSuccess, posaCardNumber, postPosaCharge]);

  return (
    <Column align="center" gap={20}>
      <Row align="center" justify="center">
        <b className="relative leading-[28px]">
          <p className="m-0">チャージ内容の確認</p>
        </b>
      </Row>
      <ChargePointDetails
        currentPoints={currentPoints}
        chargePoints={chargePoints}
        hideTotalPoints={isPointOverMax}
      />

      {isPointOverMax && (
        <p className="text-message-error px-4 text-center whitespace-pre-wrap text-[12px]">
          {`ポイントは合計で100,000pt以上保持できません。\nお使いになってから再度チャージをお試しください。`}
        </p>
      )}
      <ButtonRound
        label="この内容でチャージする"
        disabled={isPointOverMax || isPostPosaChargePending}
        onClick={handleCharge}
      />
      {isPointOverMax ? (
        <Link href="/mypage">
          <ButtonRound label="マイページに戻る" />
        </Link>
      ) : (
        <Row align="center" justify="center" className="text-[12px]">
          <Link
            href="/mypage"
            className="[text-decoration:underline] relative leading-[16px] text-[inherit] cursor-pointer"
          >
            チャージせずにマイページに戻る
          </Link>
        </Row>
      )}
    </Column>
  );
}
